const data = [
    {
      label: "Expiración SOAT",
      field: 'expiration_soat'
    },
    {
      label: "Expiración revisión técnica",
      field: 'expiration_rev_tech'
    },
    {
      label: "Vencimiento Habilitación Vehicular",
      field: 'qualification_expiration'
    },
    {
      label: "Vencimiento póliza de Resp. Civil $50,000",
      field: 'policy_expiration'
    },
    {
      label: "Vencimiento Certificado IMO",
      field: 'imo_cert_expiration'
    },
    {
      label: "Vencimiento Revisión técnica IMO",
      field: 'imo_rev_expiration'
    },
    {
      label: "Vencimiento póliza de Resp. Civil IMO  $100,000",
      field: 'imo_policy_expiration'
    },
    {
        label: "Vencimiento de botiquín",
        field: 'kit_expiration'
      },
      {
        label: "Vencimiento de Extintor",
        field: 'extinguisher_expiration'
      }
  ]
  
  export default data;
  